import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, NavLink, Outlet, useLocation } from 'react-router';

import { TABS } from './tabs';

/** Path of the tab that owns the current URL; Home owns only `/` exactly. */
function currentTab(pathname: string): string {
  return (
    TABS.find((tab) => matchPath({ path: tab.path, end: tab.path === '/' }, pathname))?.path ?? '/'
  );
}

/** App frame: the current screen above the bottom tab bar (mockup 1). */
export function AppLayout(): ReactElement {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}>
      {/* Phone-width column, centred on Telegram Desktop and Web, where the window is wide.
          `relative` keeps visually hidden headings inside it, so nothing scrolls sideways. */}
      <Box
        component="main"
        sx={{ flex: 1, p: 2, width: '100%', maxWidth: 560, mx: 'auto', position: 'relative' }}
      >
        <Outlet />
      </Box>
      <Paper
        component="nav"
        aria-label={t('app.navigation')}
        square
        elevation={0}
        sx={{
          position: 'sticky',
          bottom: 0,
          borderTop: 1,
          borderColor: 'divider',
          pb: 'env(safe-area-inset-bottom)',
        }}
      >
        <BottomNavigation showLabels value={currentTab(pathname)}>
          {TABS.map(({ path, titleKey, Icon }) => (
            <BottomNavigationAction
              key={path}
              value={path}
              label={t(titleKey)}
              icon={<Icon aria-hidden />}
              component={NavLink}
              to={path}
              end={path === '/'}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
